import styled from '@emotion/styled';

export default styled.div`
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;

    .video {
        outline: none;
        border-radius: 20px;
        margin: auto;
    }

    iframe {
        height: 53vw;
        width: 100%;
        max-height: 41.3em;
    }

    &.rounded {
        border-radius: 1em;
        overflow: hidden;
    }
`;
